import { render } from "./SignInSignUpContainer.vue?vue&type=template&id=7234d12c&scoped=true"
import script from "./SignInSignUpContainer.vue?vue&type=script&lang=js"
export * from "./SignInSignUpContainer.vue?vue&type=script&lang=js"

import "./SignInSignUpContainer.vue?vue&type=style&index=0&id=7234d12c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7234d12c"]])

export default __exports__